'use strict';
module.exports = [
  '$scope',
  'channelsService',
  '$state',
  'translateFilter',
  '$uibModal',
  'toastService',
  function ($scope, channelsService, $state, translateFilter, $uibModal, toastService) {
    $scope.channels = null;

    var mainConfig = global.ngDroAstralSituationRecordMainConfig;

    $scope.pagination = {
      page: 1,
      size: parseInt(mainConfig.PageSize),
      totalElements: 0,
      numberOfElements: 0,
      totalPages: 0,
    };

    $scope.displayedElements = function () {
      var a = ($scope.pagination.page - 1) * $scope.pagination.size + 1;
      var b =
        $scope.pagination.page * $scope.pagination.size > $scope.pagination.totalElements
          ? $scope.pagination.totalElements
          : $scope.pagination.page * $scope.pagination.size;
      var c = $scope.pagination.totalElements;

      return a + ' &ndash; ' + b + ' di ' + c;
    };

    function findAll() {
      channelsService.findAllPaginated(
        {
          page: $scope.pagination.page - 1,
          size: $scope.pagination.size,
        },
        function (response) {
          $scope.channels = response;
          $scope.pagination.totalElements = response.totalElements;
          $scope.pagination.numberOfElements = response.numberOfElements;
          $scope.pagination.totalPages = response.totalElements / response.numberOfElements;
        }
      );
    }

    findAll({
      page: $scope.pagination.page - 1,
      size: $scope.pagination.size,
    });

    $scope.pageChanged = function () {
      findAll({
        page: $scope.pagination.page - 1,
        size: $scope.pagination.size,
      });
    };

    $scope.add = function () {
      $state.go('situation-record-channel-add');
    };

    $scope.edit = function (item) {
      $state.go('situation-record-channel-edit', { id: item.id });
    };

    $scope.delete = function (item) {
      var dialogInst = $uibModal.open({
        template: require('../../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler eliminare ' + item.comments[0].comment + '?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          channelsService.delete(
            { id: item.id },
            function () {
              toastService.createSuccessToast('Canale eliminato con successo');
              $scope.pageChanged();
            },
            function (error) {
              toastService.createErrorToast("Errore durante l'eliminazione del canale");
              $scope.error = error.data;
            }
          );
        },
        function () {}
      );
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/channel/channelList/channelListCtrl.js
// module id = 249
// module chunks = 0